"use client";

import Image from "next/image";
import { sizes } from "@/styles/mediaQueries";

interface CampaignImageProps {
  imageXs?: string;
  imageS?: string;
  imageM?: string;
  imageL?: string;
  imageXl?: string;
  imageAlt?: string;
  className?: string;
}

const CampaignImage: React.FC<CampaignImageProps> = ({
  imageXs = "Campaign_Mobile.jpg",
  imageS = "Campaign_List_s.jpg",
  imageM = "Campaign_List_m.jpg",
  imageL = "Campaign_List_l.jpg",
  imageXl = "Campaign_List_xl.jpg",
  imageAlt = "weg.de Kampagne",
  className = "",
}) => {
  const baseUrl = "https://media.staticroot.com";
  const basePath = "DAM/wegde%20photos/funnel";

  const createImageUrl = (filename: string, width: number) =>
    `${baseUrl}/${basePath}/${filename}?tr=f-auto,q-70,w-${width}`;

  return (
    <div
      className={className}
      style={{ width: "100%", marginBottom: "1rem", marginTop: "1rem" }}
    >
      <picture style={{ width: "100%" }}>
        {imageXs && (
          <source
            media={`(max-width: ${sizes.screenXsMin - 1}px)`}
            srcSet={createImageUrl(imageXs, 400)}
          />
        )}
        {imageS && (
          <source
            media={`(max-width: ${sizes.screenSmMin - 1}px)`}
            srcSet={createImageUrl(imageS, sizes.screenSmMin)}
          />
        )}
        {imageM && (
          <source
            media={`(max-width: ${sizes.screenMdMin - 1}px)`}
            srcSet={createImageUrl(imageM, sizes.screenMdMin)}
          />
        )}
        {imageL && (
          <source
            media={`(max-width: ${sizes.screenXlMin - 1}px)`}
            srcSet={createImageUrl(imageL, sizes.screenLgMin)}
          />
        )}
        {imageXl && (
          <source
            media={`(min-width: ${sizes.screenXlMin}px)`}
            srcSet={createImageUrl(imageXl, sizes.screenXlMin)}
          />
        )}
        <Image
          src={createImageUrl(imageXl, sizes.screenXlMin)}
          alt={imageAlt}
          width={sizes.screenXlMin}
          height={130}
          style={{ width: "100%", height: "auto" }}
          priority
          sizes="(max-width: 768px) 100vw, (max-width: 1260px) 50vw, 33vw"
        />
      </picture>
    </div>
  );
};

export default CampaignImage;
